<template>
  <v-dialog
    id="code-modal-form"
    ref="codeModalForm"
    v-model="$store.state.codeModalFormOpen"
    width="400"
    persistent
    no-click-animation>
    <form
      @submit.prevent="createCode">
      <v-container
        class="px-5 pb-2 pt-0">
        <!-- Title -->
        <v-row>
          <v-col
            class="d-flex pr-0">
            <h2>
              <span
                v-if="$store.getters.isActiveCodeDirty">
                *
              </span>
              Add {{activeCodeConfig.entity}}
            </h2>
            <v-btn
              class="square ml-auto"
              type="button"
              text
              @click="closeCodeModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Title -->

        <!-- Code -->
        <v-row>
          <v-col>
            <v-text-field
              id="code"
              name="code"
              ref="code"
              v-model="activeCode[activeCodeConfig.property]"
              :label="activeCodeLabel"
              :readonly="$store.getters.isLoadingActive"
              hide-details>
            </v-text-field>
          </v-col>
        </v-row>
        <!-- / Code -->

        <!-- Buttons -->
        <v-row>
          <v-col
            class="d-flex">
            <v-btn
              class="ml-auto"
              type="submit"
              color="primary"
              :disabled="$store.getters.isLoadingActive
                || !$store.getters.isActiveCodeDirty">
              Save
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Buttons -->
      </v-container>
    </form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'CodeModalForm',
  computed: {
    activeCode() {
      return this.$store.state.activeCode;
    },
    activeCodeConfig() {
      return this.$store.state.activeCodeConfig;
    },
    activeCodeLabel() {
      return `${_.startCase(this.activeCodeConfig.property)}:`;
    },
  },
  methods: {
    closeCodeModal(skipDirtyCheck) {
      const confirm = () => {
        this.$store.commit('closeCodeModalForm');
      };

      if (this.$store.getters.isActiveCodeDirty && !skipDirtyCheck) {
        this.showConfirm(
          'Are you sure you want to leave without saving?',
          'You have unsaved changes',
        ).then(confirm, _.noop);
      } else {
        confirm();
      }
    },
    createCode() {
      this.$store.dispatch('createCode')
        .then(() => {
          this.closeCodeModal(true);
        });
    },
  },
};
</script>

<style lang="scss"></style>
